var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4009 3.19971H4.80031C3.91525 3.19971 3.19971 3.91525 3.19971 4.80031V14.4009C3.19971 15.2845 3.91525 16 4.80031 16H14.4009C15.2845 16 16 15.2845 16 14.4009V4.80031C16 3.91525 15.2845 3.19971 14.4009 3.19971ZM14.4009 14.4009H4.80031V4.80031H14.4009V14.4009Z",
    fill: "#326164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5209 14.5209H4.6803V4.6803H14.5209V14.5209ZM14.4009 3.31972H4.80031C3.98153 3.31972 3.31972 3.98153 3.31972 4.80031V14.4009C3.31972 15.2181 3.98146 15.88 4.80031 15.88H14.4009C15.2182 15.88 15.88 15.2182 15.88 14.4009V4.80031C15.88 3.98146 15.2181 3.31972 14.4009 3.31972ZM4.80031 3.19971H14.4009C15.2845 3.19971 16 3.91525 16 4.80031V14.4009C16 15.2845 15.2845 16 14.4009 16H4.80031C3.91525 16 3.19971 15.2845 3.19971 14.4009V4.80031C3.19971 3.91525 3.91525 3.19971 4.80031 3.19971ZM14.4009 14.4009V4.80031H4.80031V14.4009H14.4009Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5991 1.5991H12.8003V0H1.5991C0.715544 0 0 0.715544 0 1.5991V12.8003H1.5991V1.5991Z",
    fill: "#326164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.47909 1.47909H12.6803V0.120007H1.5991C0.781822 0.120007 0.120007 0.781822 0.120007 1.5991V12.6803H1.47909V1.47909ZM1.5991 12.8003H0V1.5991C0 0.715544 0.715544 0 1.5991 0H12.8003V1.5991H1.5991V12.8003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.d5d74aadd17338973e6c4e53b4cc9481.svg";
export { ForwardRef as ReactComponent };